<template>
  <div ref="warp" class="tourist">
    <PageHeader title="租客/客源" @GoAdd="GoAdd" />
    <PageForm
      :dishTypeOpts="dishTypeOpts"
      :flag="flag"
      :form="form"
      :industryCategory="industryCategory"
      :industrySubclass="industrySubclass"
      :time="time"
      :typeOptions="typeOptions"
      @export_touristList="export_touristList"
      @handleQuery="handleQuery"
      @handleReset="handleReset"
      @industrySubclassFn="industrySubclassFn"
      @intValidate="intValidate"
      @timeSwitching="timeSwitching"
    />
    <PageTable
      :activeNum="activeNum"
      :curLook="curLook"
      :dataLists="DataList"
      :dateList="dateList"
      :dishTypeOpts="dishTypeOpts"
      :form="form"
      :nameTouristComponent="nameTouristComponent"
      :pageNum="pageNum"
      :pageSize="pageSize"
      :pagination="pagination"
      :total="total"
      type="tenants"
      @GoSorter="GoSorter"
      @changeTabs="changeTabs"
      @changeUpDown="changeUpDown"
      @dateListChange="dateListChange"
      @onShowSizeChange="onShowSizeChange"
      @pageChange="pageChange"
    />
    <div v-show="listLoding" class="topcenter">
      <LoadingModel></LoadingModel>
    </div>
  </div>
</template>

<script>
import touristApi from '@/api/system/tourist/tourist.js'
import {
  getBeginLastMonth,
  getBeginLastWeek,
  getBeginMonth,
  getBeginToday,
  getBeginWeek,
  getBeginYesterday,
  getCurrentDate,
  getEndLastMonth,
  getEndLastWeek,
  getEndMonth,
  getEndWeek,
  getEndYesterday,
  getYMD
} from '@/utils/date.js'
import moment from 'moment'
import touristList from '../modules/cards/touristList.vue'
import LoadingModel from '@/components/Loading'
import PageHeader from './modules/header.vue'
import PageForm from './modules/pageForm.vue'
import PageTable from './modules/pageTable.vue'

import { treeSelectMixin } from '@/mixin/treeSelect'
import { locationSelectMixin } from '@/mixin/locationSelect'

export default {
  name: 'TouristList',
  components: {
    touristList,
    LoadingModel,
    PageHeader,
    PageForm,
    PageTable
  },
  mixins: [treeSelectMixin, locationSelectMixin],
  computed: {
    getUserInfo () {
      return this.$store.getters.userInfo
    }
  },
  data () {
    // 数字正则
    const validateNumber = (rule, value, callback) => {
      const reg = /^\+?[1-9][0-9]*$/
      if (value === '') {
        callback()
      } else if (!reg.test(value)) {
        callback(0)
      } else {
        callback()
      }
    }

    const getInit = () => {
      const arr = ['ZJL']
      const loginRole = this.$getters.userInfo.data.roles
      let status = false
      loginRole.forEach((el) => {
        if (arr.includes(el)) {
          status = true
        }
      })
      return status
    }
    const initType = getInit()
    return {
      nameTouristComponent: 'TouristList', // 增加标识 判断是否进入的是租客列表 nameTouristComponent===TouristList 租客列表
      industryCategory: [],
      industrySubclass: [],
      pagination: {
        pageSizeOptions: ['10', '20', '30']
      },
      form: {
        requirementResourceType: initType ? 1 : 2, // 1:全部客源 2：我的客源 3：小组客源 4：门店客源 5：公客 6：即将掉盘
        requirementSort: 1, // 房源排序（1：默认 2：带看 ）
        sortType: 'DESC', // 排序规则 ASC / DESC
        accendantId: undefined, // 部门人员ID
        alloweCateringTypeId: undefined,
        dateType: 0, // 日期类型(1：跟进、2：录入)
        deptId: undefined, // 部门ID
        districtId: undefined,
        businessDistrictId: undefined,
        streetId: undefined,
        startTime: '',
        endTime: '',
        floorEnd: '',
        floorStart: '',
        isAsc: '',
        isCatering: undefined,
        orderByColumn: '',
        rentExpenseEnd: '',
        rentExpenseStart: '',
        requirementAreaEnd: '',
        requirementAreaStart: '',
        requirementStatus: null, // 客源需求状态
        search: '',
        shopType: '', // 商铺类型ID
        industryCategoryId: undefined, // 行业大类
        industrySubclassId: undefined, // 行业子类

        // 多选
        districtIdList: [],
        businessDistrictIdList: [],
        alloweCateringTypeIdList: [],
        streetIdList: [],
        dishTypeOpts: undefined,
        trades: null
      },
      time: {
        rentExpenseStart: '',
        rentExpenseEnd: ''
      },
      vForm: {
        districtVal: undefined,
        businessVal: undefined
      },
      listLoding: false,
      flag: 1,
      DataList: [], // 数据列表
      // districtList: [], // 区域列表
      // businessDistrict: [], // 商圈
      StreetData: [], // 街道
      query: {},
      // 分页数据
      total: 0, // 总条数
      pageNum: 1, // 当前页
      pageSize: this.$getters.pageSize,

      // 数据字典
      isOptions: [], // 餐饮类型
      foodCat: [],
      typeOptions: [
        {
          dictValue: '',
          dictLabel: '全部'
        }
      ],
      dishTypeOpts: [],

      // 日期时间筛选
      dateList: ['今日', '昨天', '本周', '上周', '本月', '上月', '全部'],
      // 部门人员
      dept: [],
      userList: [],
      activeNum: '1',
      curLook: false // 带看激活标识
    }
  },
  methods: {
    // 导出-客源信息查询列表
    export_touristList () {
      if (this.form.startTime) {
        this.form.startTime = moment(this.form.startTime).format('YYYY-MM-DD')
      }
      if (this.form.endTime) {
        this.form.endTime = moment(this.form.endTime).format('YYYY-MM-DD')
      }
      if (this.form.dateType === 0) {
        this.form.dateType = 0
      }

      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据',
        onOk () {
          that.downloadPost(
            '/lesseeRequirement/export',
            {
              ...that.form
            },
            `p_${new Date().getTime()}.xls`
          )
        },
        onCancel () {}
      })
    },
    // 获取行业分类（行业小类）
    industrySubclassFn (val) {
      const params = {
        industryCategoryType: 2, // 行业类型（1：行业分类（行业大类） 2：经营行业（行业小类））
        parentId: val
      }
      touristApi.industryCategory(params).then((res) => {
        if (res.code === 200) {
          this.industrySubclass = res.data
        }
      })
    },

    // 获取行业分类（行业大类）
    industryCategoryFn () {
      const params = {
        industryCategoryType: 1 // 行业类型（1：行业分类（行业大类） 2：经营行业（行业小类））
      }
      touristApi.industryCategory(params).then((res) => {
        if (res.code === 200) {
          this.industryCategory = res.data
        }
      })
    },
    // 是否首页进入-即将掉盘
    dataList () {
      if (this.$route.query.str) {
        this.activeNum = '6'
        this.changeTabs(6)
      } else {
        this.activeNum = '1'
        this.getDataList()
      }
    },
    // 排序请求
    GoSorter (requirementSort, sortType) {
      this.form.sortType = sortType
      this.form.requirementSort = requirementSort
      this.getDataList()
    },
    // 获取列表数据
    async getDataList () {
      this.listLoding = true
      console.log(this.form, 'forms')
      const res = await touristApi.lesseeRequirementList({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        ...this.form
      })
      this.listLoding = false
      this.total = res.data.total
      this.DataList = res.data.records
    },

    // 清空表单按钮
    handleReset () {
      this.form.alloweCateringTypeId = undefined
      this.form.requirementAreaStart = ''
      this.form.requirementAreaEnd = ''
      this.form.isCatering = undefined
      this.form.floorStart = ''
      this.form.floorEnd = ''
      this.form.streetName = ''
      this.form.streetId = undefined
      this.form.search = ''
      this.form.districtId = undefined
      this.form.businessDistrictId = undefined
      this.form.rentExpenseStart = ''
      this.form.rentExpenseEnd = ''
      this.form.shopType = '' // 商铺类型ID
      this.form.accendantId = undefined // 部门人员ID
      this.form.deptId = undefined // 部门ID
      this.form.dateType = 0
      this.form.startTime = undefined
      this.form.endTime = undefined
      this.form.requirementStatus = null
      this.form.industryCategoryId = undefined
      this.form.industrySubclassId = undefined
      this.form.dishTypeOpts = undefined
      this.industrySubclass = []
      this.time = {
        rentExpenseStart: '',
        rentExpenseEnd: ''
      }

      // 多选
      this.form.districtIdList = []
      this.form.businessDistrictIdList = []
      this.form.alloweCateringTypeIdList = []
      this.form.streetIdList = []

      // this.businessDistrict = [] // 商圈
      this.StreetData = [] // 街道
      this.getDistrict()
      this.userList = []
      this.getDeptList()
      this.getDataList() // 查询列表
      this.curLook = false
      this.flag = 1
      this.form.trades = null
    },
    // 查询表单按钮
    handleQuery () {
      if (this.form.startTime) {
        this.form.startTime = moment(this.form.startTime).format('YYYY-MM-DD')
      }
      if (this.form.endTime) {
        this.form.endTime = moment(this.form.endTime).format('YYYY-MM-DD')
      }
      if (this.form.dateType === 0) {
        this.form.dateType = 0
      }
      this.getDataList()
    },
    disabledDate (current) {
      return current && current > moment().endOf('day')
    },

    // 跳转新增客源页面
    GoAdd () {
      sessionStorage.setItem('history', JSON.stringify({ fromPage: 'add' }))
      this.$router.push('/tourist/add')
    },

    // 获取部门列表
    getDeptList () {
      touristApi.getDeptList().then((res) => {
        if (res.code === 200) {
          this.dept = res.data.map((item) => {
            return {
              deptId: item.deptId,
              deptName: item.deptName
            }
          })
        }
      })
    },

    // 获取部门人员列表
    chooseDept (val) {
      this.form.accendantId = undefined
      touristApi.getUserList({ deptId: val }).then((res) => {
        if (res.code === 200) {
          this.userList = res.rows
        }
      })
    },

    // 租金范围
    timeSwitching () {
      if (this.flag === 1) {
        this.form.rentExpenseStart = this.time.rentExpenseStart
        this.form.rentExpenseEnd = this.time.rentExpenseEnd
      } else if (this.flag === 0) {
        this.form.rentExpenseStart = this.time.rentExpenseStart * 30
        this.form.rentExpenseEnd = this.time.rentExpenseEnd * 30
      } else {
        this.form.rentExpenseStart = ''
        this.form.rentExpenseEnd = ''
        this.time.rentExpenseStart = ''
        this.time.rentExpenseEnd = ''
      }
    },

    // 切换选项卡
    changeTabs (key) {
      if (key == '3') {
        this.form.deptId = this.getUserInfo.data.user.deptId
      } else if (key == '8') {
        this.form.deptId = this.getUserInfo.data.user.deptId
      }
      console.log(key, '选项卡')
      this.form.requirementResourceType = Number(key)
      this.activeNum = key
      this.getDataList()
    },

    // 切换分页
    pageChange (page, pageSize) {
      this.pageNum = page
      this.pageSize = pageSize
      this.getDataList()
    },
    onShowSizeChange (current, pageSize) {
      this.pageSize = pageSize
      this.pageNum = 1
      this.getDataList()
    },

    // 默认，带看切换
    changeUpDown () {
      this.curLook = true
      this.form.sortType = this.form.sortType === 'ASC' ? 'DESC' : 'ASC'
      this.form.requirementSort = 2
      this.getDataList()
    },

    // 时间下拉框
    dateListChange (val) {
      this.form.startTime =
        val === '今日'
          ? getYMD('-', getBeginToday())
          : val === '昨天'
          ? getYMD('-', getBeginYesterday())
          : val === '本周'
          ? getYMD('-', getBeginWeek())
          : val === '上周'
          ? getYMD('-', getBeginLastWeek())
          : val === '本月'
          ? getYMD('-', getBeginMonth())
          : val === '上月'
          ? getYMD('-', getBeginLastMonth())
          : ''
      this.form.endTime =
        val === '今日'
          ? getYMD('-', getCurrentDate())
          : val === '昨天'
          ? getYMD('-', getEndYesterday())
          : val === '本周'
          ? getYMD('-', getEndWeek())
          : val === '上周'
          ? getYMD('-', getEndLastWeek())
          : val === '本月'
          ? getYMD('-', getEndMonth())
          : val === '上月'
          ? getYMD('-', getEndLastMonth())
          : ''
      this.form.requirementSort = 2
      this.getDataList()
    },

    // int验证
    intValidate (fieldName) {
      const val = fieldName === 'rentExpenseStart' || fieldName === 'rentExpenseEnd' ? this.time[fieldName] : this.form[fieldName]
      const reg = /^[0-9]{1,6}$/
      if (!reg.test(val)) {
        if (fieldName === 'rentExpenseStart' || fieldName === 'rentExpenseEnd') {
          this.time[fieldName] = ''
        } else {
          this.form[fieldName] = ''
        }
      }
    }
  },
  created () {
    // 获取数据列表
    this.dataList()

    // 获取部门列表
    this.getDeptList()
    this.industryCategoryFn()

    // 字典列表
    this.getDicts('house_status').then((response) => {
      this.isOptions = response.data
    })
    this.getDicts('shop_type').then((response) => {
      this.typeOptions = this.typeOptions.concat(response.data)
    })
    // 盘别
    this.getDicts('dish_type').then((response) => {
      this.dishTypeOpts = response.data
    })
    // 餐饮类型
    this.getDicts('repast_type').then((response) => {
      this.foodCat = response.data
    })
  },

  mounted () {
    console.log(this.getUserInfo, 'getuSERINFO')
  },

  watch: {
    // 监听客户是否点击切换租金单位
    flag () {
      if (this.flag === 1) {
        this.time.rentExpenseStart = this.form.rentExpenseStart
        this.time.rentExpenseEnd = this.form.rentExpenseEnd
      } else if (this.flag === 0) {
        this.time.rentExpenseStart = this.form.rentExpenseStart ? (this.form.rentExpenseStart / 30).toFixed(2) : this.time.rentExpenseStart
        this.time.rentExpenseEnd = this.form.rentExpenseEnd ? (this.form.rentExpenseEnd / 30).toFixed(2) : this.time.rentExpenseEnd
      } else {
        this.time.rentExpenseStart = ''
        this.time.rentExpenseEnd = ''
        this.form.rentExpenseStart = ''
        this.form.rentExpenseEnd = ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}

.tourist {
  height: 100%;

  .topcenter {
    position: fixed;
    top: 43%;
    left: 50%;
  }
}
</style>
